import React from 'react';
import { Coins, Wallet } from 'lucide-react';
import { IEVMTransaction, TransactionAmount } from 'src/types';

interface TransactionDetailsProps {
  transaction: IEVMTransaction;
  formatAmount: (amount: number | TransactionAmount) => string;
}

export const EVMTransactionDetails: React.FC<TransactionDetailsProps> = ({
  transaction,
  formatAmount,
}) => {
  return (
    <div className="rounded-lg bg-gray-50 p-6">
      <h2 className="mb-4 text-lg font-semibold">Transaction Details</h2>
      <div className="space-y-2">
        <div className="flex items-start gap-4">
          <div className="flex min-w-[200px] items-center gap-2">
            <Coins className="h-5 w-5 text-gray-500" />
            <h2 className="text-sm font-semibold text-gray-500">Value</h2>
          </div>
          <div className="flex-1">
            <p className="text-md font-medium">
              {formatAmount(transaction.amount)}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="flex min-w-[200px] items-center gap-2">
            <Wallet className="h-5 w-5 text-gray-500" />
            <h2 className="text-sm font-semibold text-gray-500">
              Transaction Fee
            </h2>
          </div>
          <div className="flex-1">
            <p className="text-md font-medium">
              {formatAmount(transaction.txfee)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
